import React from 'react'
import {findDOMNode} from 'react-dom'

import OptionsItem from './tabs-option-item'

type Props = {
    className?              : string

    items                   : {
        id                      : ID
        title                   : string
        icon?                   : string
        width?                  : number //required only for proper selection transition
        count?                  : number
        subItems?               : any[]
        subItemSelectedId?      : ID
        hint?                   : string
    }[],
    selectedId?             : ID
    subItemSelectedId?      : ID

    skin                    : 'underline-on-gray' | 'colored' | 'submenu' | 'submenu-dark' | 'pills' | 'pills-v2' | 'pills-blue' | 'radio' | 'square' | 'menu'
    iconOnly?               : boolean
    disabled?               : boolean

    onSelectTab?            : func
    onImmediateSelectTab?   : func
}

type State = {
    selectedTab?        : ID
    subItemSelectedId?  : ID
}

export default class TabsSelector extends React.Component<Props, State> {

    private onSelectTabCallbackDebounce : any
    private selectionItem               : any

    static defaultProps = {
        skin: 'submenu'
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            selectedTab: props.selectedId
        }
    }

    UNSAFE_componentWillReceiveProps(newProps: Props) {
        if (newProps.selectedId !== this.state.selectedTab) {
            this.setState({
                selectedTab: newProps.selectedId
            })
        }
    }

    componentDidMount() {
        this.onSelectTabCallbackDebounce = _.debounce(this.onSelectTabCallback, 400)
        this.selectionItem = findDOMNode(this.refs.selection)
        setTimeout(this.updateSelectionArea, 50)
        // setTimeout(this.updateSelectionArea, 1000);
        //setTimeout required for proper work in Chrome
        //otherwise this.refs["item_"+this.state.selectedTab] offsetLeft and clientWidth
        //are not always up to date on this.updateSelectionArea() execution
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevState.selectedTab !== this.state.selectedTab ||
            prevState.subItemSelectedId !== this.state.subItemSelectedId)
            this.updateSelectionArea()
    }

    updateSelectionArea = () => {
        const el: any = findDOMNode(this.refs["item_"+this.state.selectedTab])
        if (el) {
            this.selectionItem.classList.remove("hidden");

            switch (this.props.skin) {
                // case 'controls':
                //     this.selectionItem.style["left"] = (el.offsetLeft + 0) + 'px'
                //     this.selectionItem.style["width"] = (el.clientWidth +1) + 'px'
                //     break;
                default:
                    this.selectionItem.style["left"] = (el.offsetLeft + 1) + 'px'
                    this.selectionItem.style["width"] = (el.clientWidth - 1) + 'px'
                    break
            }
        }
    }

    onSelectTab = (id: ID, subItemSelectedId?: ID) => {
        if (this.props.disabled) return

        this.onSelectTabCallbackDebounce()

        this.setState({
            selectedTab         : id,
            subItemSelectedId   : subItemSelectedId //for update only
        },()=>{
            if (this.props.onImmediateSelectTab) {
                this.props.onImmediateSelectTab(id, subItemSelectedId)
            }
        })
    }

    onSelectTabCallback = () => {
        if (this.props.onSelectTab) {
            this.props.onSelectTab(this.state.selectedTab)
        }
    }

    render() {

        const mainClasses = Classes('gd-tabs-selector', this.props.skin+"-skin", this.props.className, {
            "is-disabled"   : this.props.disabled,
            "icon-only"     : this.props.iconOnly
        })

        return (
            <div className={mainClasses}>
                {_.map(this.props.items, (item)=>
                    <OptionsItem key                = {item.id}
                                 ref                = {"item_"+item.id}
                                 data               = {item}
                                 selectionIcon      = {this.props.skin === "radio"}
                                 selected           = {this.state.selectedTab === item.id}
                                 subItemSelectedId  = {this.props.subItemSelectedId}
                                 onSelectTab        = {this.onSelectTab}/>
                )}
                <div className="option-tab selection hidden" ref="selection"/>
            </div>
        )
    }
}